import { Component, computed, effect, inject, input, } from '@angular/core';
import { TooltipRewards } from '../tooltip-rewards/tooltip-rewards';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { TooltipQR } from '../tooltip-qr/tooltip-qr';
import { SpeedDialModule } from 'primeng/speeddial';
import { CommonModule } from '@angular/common';
import { AvatarModule } from 'primeng/avatar';
import { AccountApiService } from '@ribera-web/auth-data-acess';
import { UserDataStateService } from '@ribera-web/auth-data-acess';
import { ShellDataService } from '@ribera-web/auth-data-acess';
import { RiberaModalContainerService } from '@ribera-web/ribera-modal-container-ui'
import { PromotersChanguePerfil } from '../promoters-changue-perfil/promoters-changue-perfil';
import { JwtUtil } from '@ribera-web/token-decodifier-service';
import { PopoverModule } from 'primeng/popover';
import { RiberaDefaultBtn } from "@ribera-web/ribera-default-btn";

export interface ProfileHeaderData {
  name: string;
  avatarUrl?: string;
  membershipLevel: string;
  progressPercent: number; // 0-100
  isPromotor: boolean;
}

@Component({
  selector: 'lib-promoters-profile-ui',
  imports: [CommonModule, SpeedDialModule, AvatarModule, PopoverModule, RiberaDefaultBtn, TooltipQR],
  templateUrl: './promoters-profile-ui.html',
  styleUrl: './promoters-profile-ui.scss',
})
export class PromotersProfileUi {

  accountApiService = inject(AccountApiService);
  userDataSateService = inject(UserDataStateService);
  shellDataService = inject(ShellDataService);
  modalService = inject(RiberaModalContainerService);
  private jwtUtil = inject(JwtUtil);

  isCollapsed = input<boolean>(false);

  loggedUserName = '';

  data!: ProfileHeaderData;

  private rewardOverlay?: OverlayRef;
  private qrOverlay?: OverlayRef;

  avatarBkp = 'shell/profile/mask-group.svg';
  progressPercent = 50; // 0 - 100
  speedDialVisible = false;
  tooltipQr = false;

  private overlay = inject(Overlay);

  isUserTyePromoter = computed(() => {
    const token = localStorage.getItem('accessToken') || '';
    if (!token) return false;
    const userData = this.jwtUtil.getUserFromToken(token);
    return userData.user_type === 1 ? true : false;
  });

  private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';


  constructor() {
    const token = localStorage.getItem('accessToken');
    if (token && token !== this.DEFAULT_TOKEN) {
      try {
        const userData = this.jwtUtil.getUserFromToken(token);
        this.loggedUserName = userData.fullName || userData.name || '';
      } catch {
        // Ignorar errores de parseo y mantener valores por defecto
      }
    }
  }

  get profiles() {
    return ([
      { label: 'Perfil Socio', icon: 'shell/profile/user-tie.svg' },
      { label: 'Perfil Promotor', icon: 'shell/profile/business.svg' }
    ]);
  }

  readonly r = 45;
  readonly circumference = 2 * Math.PI * this.r;
  get dashOffset(): number {
    const p = Math.max(0, Math.min(100, this.progressPercent ?? 0));
    return this.circumference * (1 - p / 100);
  }


  // onToggleSpeedDial(event?: Event) {
  //   event?.stopPropagation();
  //   this.speedDialVisible = !this.speedDialVisible;
  // }

  onToggleSpeedDial(event?: Event) {
    event?.stopPropagation();
    const ref = this.modalService.open(PromotersChanguePerfil, {
      title: 'Perfiles',
      showActionsButtons: false
    });


    ref.onClose.subscribe(result => {
      // if(result){
      //   this.apiService.rejectPromoter(user.id, result.reason, result.description).subscribe({
      //     next: (data) => {
      //       const message = data?.message ?? 'Operación completada';
      //       this.alertModalUiService.show(message, 'success', 'Solicitud Rechazada', 'Continuar', false);
      //     },
      //     error: () => {
      //       this.alertModalUiService.show('Error al rechazar el promotor', 'error', 'Error', 'Continuar', false);
      //     }
      //   });
      // }
    });
  }

  goToRibera() {
    this.shellDataService.togglePromotorPerfil()
    this.speedDialVisible = false;
  }

  perfilActivo = computed(() => {
    return this.shellDataService.isPromotorPerfil() ? 'Perfil Promotor' : 'Perfil Socio';
  });

  messagePerfil = computed(() => {
    return this.shellDataService.isPromotorPerfil() ? 'Bienvenid@, empieza a ganar puntos hoy.'
      : 'Continua mejorando tu nivel de membresía';
  });


  openReward(button: HTMLElement) {
    if (this.rewardOverlay) {
      this.closeReward();
      return;
    }

    this.rewardOverlay = this.overlay.create({
      positionStrategy: this.overlay.position()
        .flexibleConnectedTo(button)
        .withPositions([
          {
            originX: 'end',
            originY: 'top',
            overlayX: 'start',
            overlayY: 'top',
          },
          {
            originX: 'start',
            originY: 'top',
            overlayX: 'end',
            overlayY: 'top',
          }
        ]),

      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });

    const portal = new ComponentPortal(TooltipRewards);
    const tooltipRef = this.rewardOverlay.attach(portal);

    tooltipRef.instance.close.subscribe(() => this.closeReward());
    this.rewardOverlay.backdropClick().subscribe(() => this.closeReward());
  }

  closeReward() {
    this.rewardOverlay?.dispose();
    this.rewardOverlay = undefined;
  }

  toggle = false;

  viewQr() {
    this.modalService.open(TooltipQR, {
      title: 'Código de Promotor',
      showActionsButtons: false,
    });
  }


  openQr(button: HTMLElement) {
    if (this.qrOverlay) {
      this.closeQr();
      return;
    }

    this.qrOverlay = this.overlay.create({
      positionStrategy: this.overlay.position()
        .flexibleConnectedTo(button)
        .withPositions([
          {
            originX: 'end',
            originY: 'center',
            overlayX: 'start',
            overlayY: 'center',
          },
          {
            originX: 'start',
            originY: 'center',
            overlayX: 'end',
            overlayY: 'center',
          }
        ]),

      scrollStrategy: this.overlay.scrollStrategies.reposition(),
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });

    const portal = new ComponentPortal(TooltipQR);
    const tooltipRef = this.qrOverlay.attach(portal);

    tooltipRef.instance.close.subscribe(() => this.closeQr());
    this.qrOverlay.backdropClick().subscribe(() => this.closeQr());
  }

  closeQr() {
    this.qrOverlay?.dispose();
    this.qrOverlay = undefined;
  }

}
